// tslint:disable

export const riskWarningsForTradeBuy = [
  {
    id: 1,
    title: 'I have read, understood and agree to the risk warning about incomplete information',
    text: `Directors of the underlying companies often have more information than shareholders. Employees may know things that you do not know about the company. Existing investors that you are purchasing these shares from most likely have more information about the history and status of the underlying company than you. New investors will have the least Information and therefore take the most risk.
           When purchasing SPV shares through our secondary market you are subject to greater risks than other shareholders due to a lack of Information about the underlying company owned by the SPV. You maybe buying shares from a director, employee or shareholder that has significantly more information than you that may lead to the complete loss of your investment capital as they are not subject to the same disclosure and reporting rules of a publicly traded company.`
  },
  {
    id: 2,
    title: 'I have read, understood and agree to the risk warning about indirect investors',
    text: `You are not buying direct shares in the company listed. The shares will be owned by a Special Purpose Vehicle (SPV) held and operated by BnkToTheFuture Capital SPC and BnkToTheFuture.`
  },
  {
    id: 3,
    title: 'I have read, understood and agree to the risk warning about information rights',
    text: `As a SPV shareholder you do not have Information or voting rights in the underlying companies. While we will do all we can to represent shareholder interests and exercise any voting or information rights we may have, you will not have any right to vote or request further company Information.`
  },
  {
    id: 4,
    title: 'I have read, understood and agree to the risk warning about voting rights',
    text: `All shares on the secondary market come with no voting rights unless otherwise stated. if you purchase shares on our secondary market, these are non-voting shares and may not be attractive to potential buyers. When listing your shares on our secondary market you may lose any right to vote you may have previously held and you should read the terms carefully.`
  },
  {
    id: 5,
    title: ' I have read, understood and agree to the risk warning about illiquidity',
    text: `Any investment you make through the platform may be illiquid. While you can sell these SPV shares on our secondary market, there is no guarantee that it will be highly liquid. This means that you may not be able to sell your shares until and unless sufficient liquidity is available on our secondary market, the investee company floats on a securities exchange or is bought by another company. Even for a successful business, a flotation or purchase is unlikely to occur for a number a years from the time you make your investment.`
  },
  {
    id: 6,
    title: 'I have read, understood and agree to the risk warning about diversification',
    text: `Investing in startups should only be done as part of a diversified portfolio. This means that you should invest relatively small amounts in multiple businesses rather than a lot in one or two businesses. It also means that you should invest only a small proportion of your investable capital in startups as an asset class, with the majority of your investable capital invested in safer, more liquid assets.`
  },
  {
    id: 7,
    title: 'I have read, understood and agree to the risk warning about rarity of dividends',
    text: `Startups and early stage businesses rarely pay dividends. This means that if you invest in a business through the platform, even if it is successful you are unlikely to see any return of capital or profit unless you are able to sell your shares in the investee company or the SPV. Even for a successful business, this is unlikely to occur for a number of years from the time you make your investment.`
  },
  {
    id: 8,
    title: 'I have read, understood and agree to the risk warning about rarity of dilution',
    text: `Any investment you make through the platform is likely to be subject to dilution. This means that if the underlying business raises additional capital at a later date, it will issue new shares of the investee company to the new investors, and the percentage of the investee company that the SPV owns will decline. These new shares may also have certain preferential rights to dividends, sale proceeds and other matters, and the exercise of these rights may work to your disadvantage. Your investment may also be subject to dilution as a result of the grant of options (or similar rights to acquire shares) to employees of, service providers to or certain other parties connected with, the investee company.`
  },
  {
    id: 9,
    title: 'I have read, understood and agree to the risk warning about rarity of loss of capital',
    text: `Most startups fail, and if you invest in a business through the platform via one of our SPV’s, it is more likely that you will lose all of your invested capital than that you will see a return of capital or a profit. You should not invest more money through the platform than you can afford to lose without altering your standard of living.`
  },
]

export const agreementsForTradeBuy = [
  {
    id: 10,
    title: 'I have read, understood and agree to the Share Purchase Agreement',
    document: {
      id: 1,
      title: 'Share Purchase Agreement'
    }

  },
  {
    id: 11,
    title: 'I agree for this to represent my digital signature on all agreements.',
  },
];

// tslint:disable

export const riskWarningsForOrderSell = [
  {
    id: 1,
    title: 'I have read, understood and agree to the risk warning about incomplete information',
    text: `Directors of the underlying companies often have more information than shareholders. Employees may know things that you do not know about the company. Existing investors that you are purchasing these shares from most likely have more information about the history and status of the underlying company than you. New investors will have the least Information and therefore take the most risk.
           When purchasing SPV shares through our secondary market you are subject to greater risks than other shareholders due to a lack of Information about the underlying company owned by the SPV. You maybe buying shares from a director, employee or shareholder that has significantly more information than you that may lead to the complete loss of your investment capital as they are not subject to the same disclosure and reporting rules of a publicly traded company.`
  },
  {
    id: 2,
    title: ' I have read, understood and agree to the risk warning about information rights',
    text: `As a SPV shareholder you do not have Information or voting rights in the underlying companies. While we will do all we can to represent shareholder interests and exercise any voting or information rights we may have, you will not have any right to vote or request further company Information.`
  },
  {
    id: 3,
    title: ' I have understood that I can cancel an order, but once it has been bought it is irreversible subject to our terms and conditions.',
  },
]

export const riskWarningsForTradeSell = [
  {
    id: 1,
    title: 'I have read, understood and agree to the risk warning about incomplete information',
    text: `Directors of the underlying companies often have more information than shareholders. Employees may know things that you do not know about the company. Existing investors that you are purchasing these shares from most likely have more information about the history and status of the underlying company than you. New investors will have the least Information and therefore take the most risk.
           When purchasing SPV shares through our secondary market you are subject to greater risks than other shareholders due to a lack of Information about the underlying company owned by the SPV. You maybe buying shares from a director, employee or shareholder that has significantly more information than you that may lead to the complete loss of your investment capital as they are not subject to the same disclosure and reporting rules of a publicly traded company.`
  },
  {
    id: 2,
    title: ' I have read, understood and agree to the risk warning about information rights',
    text: `As a SPV shareholder you do not have Information or voting rights in the underlying companies. While we will do all we can to represent shareholder interests and exercise any voting or information rights we may have, you will not have any right to vote or request further company Information.`
  }
]

export const agreementsForTradeSell = [
  {
    id: 5,
    title: 'I have read, understood and agree to the Share Purchase Agreement',
    document: {
      id: 1,
      title: 'Share Purchase Agreement'
    }
  },
  {

    id: 6,
    title: 'I agree for this to represent my digital signature on all agreements.',
  }
]

export const riskWarningsForOrderBuy = [
  {
    id: 1,
    title: 'I have read, understood and agree to the risk warning about incomplete information',
    text: `Directors of the underlying companies often have more information than shareholders. Employees may know things that you do not know about the company. Existing investors that you are purchasing these shares from most likely have more information about the history and status of the underlying company than you. New investors will have the least Information and therefore take the most risk.
           When purchasing SPV shares through our secondary market you are subject to greater risks than other shareholders due to a lack of Information about the underlying company owned by the SPV. You maybe buying shares from a director, employee or shareholder that has significantly more information than you that may lead to the complete loss of your investment capital as they are not subject to the same disclosure and reporting rules of a publicly traded company.`
  },
  {
    id: 2,
    title: 'I have read, understood and agree to the risk warning about indirect investors',
    text: `You are not buying direct shares in the company listed. The shares will be owned by a Special Purpose Vehicle (SPV) held and operated by BnkToTheFuture Capital SPC and BnkToTheFuture.`
  },
  {
    id: 3,
    title: 'I have read, understood and agree to the risk warning about information rights',
    text: `As a SPV shareholder you do not have Information or voting rights in the underlying companies. While we will do all we can to represent shareholder interests and exercise any voting or information rights we may have, you will not have any right to vote or request further company Information.`
  },
  {
    id: 4,
    title: 'I have read, understood and agree to the risk warning about voting rights',
    text: `All shares on the secondary market come with no voting rights unless otherwise stated. if you purchase shares on our secondary market, these are non-voting shares and may not be attractive to potential buyers. When listing your shares on our secondary market you may lose any right to vote you may have previously held and you should read the terms carefully.`
  },
  {
    id: 5,
    title: ' I have read, understood and agree to the risk warning about illiquidity',
    text: `Any investment you make through the platform may be illiquid. While you can sell these SPV shares on our secondary market, there is no guarantee that it will be highly liquid. This means that you may not be able to sell your shares until and unless sufficient liquidity is available on our secondary market, the investee company floats on a securities exchange or is bought by another company. Even for a successful business, a flotation or purchase is unlikely to occur for a number a years from the time you make your investment.`
  },
  {
    id: 6,
    title: 'I have read, understood and agree to the risk warning about diversification',
    text: `Investing in startups should only be done as part of a diversified portfolio. This means that you should invest relatively small amounts in multiple businesses rather than a lot in one or two businesses. It also means that you should invest only a small proportion of your investable capital in startups as an asset class, with the majority of your investable capital invested in safer, more liquid assets.`
  },
  {
    id: 7,
    title: 'I have read, understood and agree to the risk warning about rarity of dividends',
    text: `Startups and early stage businesses rarely pay dividends. This means that if you invest in a business through the platform, even if it is successful you are unlikely to see any return of capital or profit unless you are able to sell your shares in the investee company or the SPV. Even for a successful business, this is unlikely to occur for a number of years from the time you make your investment.`
  },
  {
    id: 8,
    title: 'I have read, understood and agree to the risk warning about rarity of dilution',
    text: `Any investment you make through the platform is likely to be subject to dilution. This means that if the underlying business raises additional capital at a later date, it will issue new shares of the investee company to the new investors, and the percentage of the investee company that the SPV owns will decline. These new shares may also have certain preferential rights to dividends, sale proceeds and other matters, and the exercise of these rights may work to your disadvantage. Your investment may also be subject to dilution as a result of the grant of options (or similar rights to acquire shares) to employees of, service providers to or certain other parties connected with, the investee company.`
  },
  {
    id: 9,
    title: 'I have read, understood and agree to the risk warning about rarity of loss of capital',
    text: `Most startups fail, and if you invest in a business through the platform via one of our SPV’s, it is more likely that you will lose all of your invested capital than that you will see a return of capital or a profit. You should not invest more money through the platform than you can afford to lose without altering your standard of living.`
  }
]

export const agreementsForOrderBuy = [
  {
    id: 10,
    title: 'I have read, understood and agree to the Share Purchase Agreement',
    document: {
      id: 1,
      title: 'Share Purchase Agreement'
    }
  },
  {
    id: 11,
    title: 'I agree for this to represent my digital signature on all agreements.',
  },
  {
    id: 12,
    title: 'I have understood that I can cancel an order, but once it has been bought it is irreversible subject to our terms and conditions.',
  },
  {
    id: 13  ,
    title: 'I have understood that my funds will be frozen to cover eventual trade.',
  }
]


export const agreementsForOrderSell = [
  {
    id: 5,
    title: 'I have read, understood and agree to the Share Purchase Agreement',
    document: {
      id: 1,
      title: 'Share Purchase Agreement'
    }
  },
  {
    id: 6,
    title: 'I agree for this to represent my digital signature on all agreements.',
  },
];




